import { fontList } from '../../core/font-list';
import { colorListPairs, colorMap, colorListCharts } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '900 x 600',
        'value': [900, 600],
        'label': '900 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '600 x 900',
          'value': [600, 900],
          'label': '600 x 900'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 900,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText': {
      'default':  'Erwerbstätigkeit\n älterer Menschen nimmt\n immer weiter zu',
      'label': 'Titeltext Slide 1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textFontSize': {
      'default': 36,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.7,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': '#222221',
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'colorScheme': {
      'default': {
        'key': 'grijs',
        'label': 'Grijs',
        'value': ['#ffc20e', '#ffffff'],
      },
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 40,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingRight': {
      'default': 50,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingRightTitleLine': {
      'default': 160,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 100,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 40,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingBottom': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'destatisLogoY': {
      'default': 160,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'destatisLogoWidth': {
      'default': 240,
      'label': 'Breedte Destatis logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bannerHeight': {
      'default': 140,
      'label': 'Banner height',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetX': {
      'default': 17,
      'label': 'Titel afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetY': {
      'default': 210,
      'label': 'Titel afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1OffsetY': {
      'default': -40,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2OffsetY': {
      'default': 40,
      'label': 'Titel 2 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText1': {
      'default': 'Erwerbstätigenquote nach Alter',
      'label': 'Titeltext 1 Slide 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText2': {
      'default': 'Anteil der Erwerbstätigen an der Bevölkerung, in %',
      'label': 'Titeltext 2 Slide 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleColor': {
      'default': '#FFFFFF',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 38,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1Color': {
      'default': '#2B2B2D',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'title1FontSize': {
      'default': 36,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2Color': {
      'default': '#2B2B2D',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'title2FontSize': {
      'default': 28,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontWeight': {
      'default': 700,
      'label': 'Titel font dikte',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'minY': {
      'default': 0,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 100,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'steps': {
      'default': 4,
      'label': 'Schritte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Anzahl horizontale linien exkl. x-Achse',
    },
    'unitText': {
      'default': '',
      'label': 'Tekst eenheid',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'Afstand unit boven max',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 50,
      'label': 'Label ruimte Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte voor de labelteksten langs de Y-as',
    },
    'labelSpaceX': {
      'default': 90,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#6A7883',
      'label': 'Label kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 24,
      'label': 'Label font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'Label afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'Label afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legend': {
      'default': true,
      'label': 'Anzeige Legende',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'legendRows': {
      'default': 1,
      'label': 'Aantal rijen in de legend',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemWidth' : {
      'default': 15,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': -40,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 25,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText': {
      'default': 5,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'labelDecimalsY': {
      'default': '1',
      'label': 'Kommastellen',
      'type': 'number',
      'control': 'standard-number',
      'description': 'Anzahl Kommastellen',
    },
    'leftLabelX': {
      'default': '55-59',
      'label': 'Beschriftung X-Achse links',
      'type': 'string',
      'control': 'standard-control',
    },
    'middleLabelX': {
      'default': '60-64',
      'label': 'Beschriftung X-Achse mitte',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '65-69',
      'label': 'Beschriftung X-Achse rechts',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelBottom': {
      'default': 'Alter von ... bis ... Jahren',
      'label': 'Achsenbeschriftung unten',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#222221',
      'label': 'As kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 3,
      'label': 'As breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barColor': {
      'default': ['#D00', '#ffc20e'],
      'label': 'Staaf kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeColor': {
      'default': '#1f74b6',
      'label': 'Staaf rand kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeWidth': {
      'default': 0,
      'label': 'Staaf rand breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barPadding': {
      'default': 0.5,
      'label': 'Staaf tussenafstand',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Gedeelte van de grafiekbreedte gereserveerd voor padding waarde tussen 0 en 1',
    },
    'barPaddingInner': {
      'default': 60,
      'label': 'Staaf tussenafstand',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'padding tussen de staven',
    },
    'barAnimation': {
      'default': {
        'key': 'allAtOnce',
        'value': 'allAtOnce',
        'label': 'Alle staven tegelijk'
      },
      'label': 'Staaf animatie',
      'type': 'string',
      'values': [
        {
          'key': 'allAtOnce',
          'value': 'allAtOnce',
          'label': 'Alle staven tegelijk'
        },
        {
          'key': 'oneAfterTheOther',
          'value': 'oneAfterTheOther',
          'label': 'Staven één voor één'
        }
      ],
      'control': 'standard-select',
      'description': 'Animatie van de staven',
    },
    'iconWidth': {
      'default': 140,
      'label': 'Icoon breedte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Breedte van het icoon',
    },
    'iconStrokeWidth': {
      'default': 3,
      'label': 'Icoon font dikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconOffsetDeltaX': {
      'default': 0,
      'label': 'Icoon afstand delta X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetDeltaY': {
      'default': 0,
      'label': 'Icoon afstand delta Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetX': {
      'default': 440,
      'label': 'Icoon afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de linkerkant',
    },
    'iconOffsetY': {
      'default': 35,
      'label': 'Icoon afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de bovenkant',
    },
  },
  'timings': {
    'pauseBar': {
      'default': 3,
      'label': 'Diagramm tonen',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide1': {
      'default': 1,
      'label': 'Pause tussen de 1e en 2e slide',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'animateSteps': {
      'default': 0.5,
      'label': 'Animatie steps',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide2': {
      'default': 3,
      'label': 'Pause Slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 4,
      'label': 'Slide 1',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 4,
      'label': 'Slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoAnimation': {
      'default': 4,
      'label': 'Logo CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 5,
      'label': 'Pause am Ende',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['2016', '2006'], [79.0, 64.2], [55.7, 29.6], [15.4, 6.6]],
    'columnLimitMin': 1,
    'columnLimitMax': 2,
    'columnLabelNumber': 1,
    'rowLimitMin': 3,
    'rowLimitMax': 3,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primär',
      'collapsed': false,
      'keys': ['titleText', 'titleText1', 'titleText2', 'leftLabelX', 'middleLabelX', 'rightLabelX', 'labelBottom', 'legend'],
    },
    {
      'title': 'Sekundär',
      'collapsed': true,
      'keys': ['minY', 'maxY', 'steps', 'labelDecimalsY'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['slide1Animation', 'pauseBar', 'pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-destatis-triptych-bar-hor-steps/social.params.ts